// extracted by mini-css-extract-plugin
module.exports = {"wallet":"Wallet_wallet__zmYkr","account":"Wallet_account__M-50p","edit":"Wallet_edit__3GAzH","items":"Wallet_items__29WCS","header":"Wallet_header__3TLRp"};